<template>
<div id="popupContainer" style="position:absolute; top:0px; width:100%;height:100%;">
  <div id="nav" class="w-full md:w-1/2 h-12 fixed left-0 bottom-0 flex flex-row flex-5 align-start md:top-0">
    <a @click="$router.go(-1)" class="px-2" style=" text-decoration: none;">✕ exit project</a>
    </div>

    <div id="description" class="w-5/6 draggable left-0 ml-4 md:w-1/2 left-0 bottom-0" :class="{ desktop_d : !isMobile }">
      <!-- <h1>work</h1> -->
    <p id="t">{{ project.title }}</p>
    <p>{{ project.description }}</p>
    <router-link to="/available">
      <p v-if="project.for_sale"><span v-if="project.custom_text_about_availability">{{ project.custom_text_about_availability }}</span>
      <span v-else>This work is available to buy.</span></p>
    </router-link>
    </div>

<div id="scanner_content" style="position:absolute; top:25px; width:100%; height:calc(100% - 25px);">

  <div id="thumbnails" class="invisible md:visible w-4/12 left-0 ">
    <div v-for="(image, index) in project.thumbnails" :key="index" @click="scrollTo(index)" :style="{ backgroundImage: 'url(' + url + image.formats.thumbnail.url + ')' }">
    </div>
  </div>
  
  <transition name="scanner">
  <div v-if="!waitScanner" class="w-full md:w-8/12 right-0 px-3 absolute">
    <ImageLoader v-for="(image, index) in project.all_images" :key="index" class="w-full mx-auto my-3" :small="url + image.formats.thumbnail.url" :trueSize="url + image.url" :id="index"/>
  </div> 
  </transition>
</div>
    </div>  
</template>

<script>
import interact from "interactjs";
import { EventBus } from '../EventBus.js';
import ImageLoader from '@/components/ImageLoader.vue'

export default {
  name: "WorkComponent",
  components: {
    ImageLoader
  },
  props: ['isMobile'],
  data() {
    return {
      url: process.env.VUE_APP_VPS_URL,
      waitScanner: true,
      allProjects: {},
      project: {}
    }
  },
  created() {
    var selfobject = this;
    this.$http.get(selfobject.url + '/homepage-projects')
      .then(function (response) {
        selfobject.allProjects = response["data"].projects;
        selfobject.project = selfobject.allProjects.find(o => o.title === selfobject.$attrs.sTitle);
      })
  },
  mounted() {
    this.enableDragDrop();
    this.waitScanner = false;
  },
  methods: {
    enableDragDrop() {
      const htmlList = document.getElementsByClassName('draggable'); 
      for (let htmlItem of htmlList) {
      let x = 0;
      let y = 0;
        interact(htmlItem)
          .draggable({
            modifiers: [
              interact.modifiers.snap({
                targets: [interact.createSnapGrid({ x: 25, y: 25 })],
                range: Infinity,
                relativePoints: [{ x: 0, y: 0 }]
              }),
              interact.modifiers.restrict({
                restriction: document.getElementById('body'),
                elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
              })
            ],
            inertia: true
          })
          .on("dragmove", function(event) {
            x += event.dx;
            y += event.dy;

            event.target.style.webkitTransform = event.target.style.transform =
              "translate(" + x + "px, " + y + "px)";
          });
      }
    },
    scrollTo(imgIndex) {
      let elmntToView = document.getElementById(imgIndex);
      elmntToView.scrollIntoView({behavior: "smooth", inline: "nearest"});
    },
    close() {
      EventBus.$emit('close');
    }
  }
}
</script>

<style scoped>
#nav > a {
  text-transform: capitalize;
  font-family: L;
  font-size:20px;
  color: #ffffff;
  margin-bottom:5px;
}

#nav {
    z-index:100;
    cursor: pointer;
}

#nav > a {
  @apply text-left;
}

#nav > a:hover {
  color: #3a6eff;
  text-decoration: none !important;
}

.desktop_d {
  left:8vw;
}

.desktop_d p {
  font-size:18px;
}

img {
  z-index:10;
}

#thumbnails {
  position:absolute;
  /* height:60%; */
  z-index:20;
  overflow-y:auto;
  display:flex;
  flex-direction:row;
  flex-wrap: wrap;
  position: fixed;
  /* justify-content: center; */
}

#thumbnails > div {
  /* margin:0 auto 0 auto; */
  margin-left:10px;
  margin-right:10px;
  width:100px;
  height:100px;
  margin-top:15px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
      /* -moz-border-radius: 500px;
    -webkit-border-radius: 500px;
    border-radius: 500px; */
}

#thumbnails > div:hover {
  opacity:0.5;
  cursor:pointer;
}

#popupContainer {
  @apply absolute overflow-y-auto overflow-x-hidden w-full h-full top-0 z-20;
  -webkit-overflow-scrolling: touch;
}

#title {
  top:45vh;
  left:25%;
  width:20%;
}

#t {
  font-family: L;
  text-transform: upper;
  margin-bottom:0px;
}


#description, #title {
  position:fixed;
  background-color:rgb(238, 238, 238);
  border: 1px solid black;
  background-image: url('../assets/drag.svg');
  background-position-y: top;
  background-size: 15px;
  background-position-x: left;
  background-repeat: no-repeat;
  z-index:75;
  padding:10px;
  bottom:9vh;
  pointer-events:all;
  touch-action: none
}

p {
  margin-block-start: 4px;
  margin-block-end: 6px;
  text-align:left;
  padding-left:5px;
  font-size:16px;
  font-family: Sneaky;
}

/* SCANNER TRANSITION */
.scanner-enter-active {
  transition: 
  transform 1.2s 0s
}

.scanner-leave-active {
  transition: 
  transform 1.2s 0s
}

.scanner-enter, .scanner-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translate(0, 100%);
}

</style>